import React from 'react';

/**
 * Renders a diagonal watermark on every printed page.
 * Invisible on screen; appears only during print via CSS media query.
 * If text is empty or not provided, no watermark is rendered.
 */
const PrintWatermark = ({ text }) => {
  if (!text) return null;

  return (
    <>
      <style type="text/css">{`
        .print-watermark { display: none; }
      `}</style>
      <style type="text/css" media="print">{`
        .print-watermark {
          display: flex !important;
          align-items: center;
          justify-content: center;
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          transform: rotate(-45deg);
          font-size: 52px;
          font-weight: 700;
          color: rgba(150, 0, 0, 0.12);
          white-space: nowrap;
          pointer-events: none;
          z-index: 9999;
          letter-spacing: 3px;
          text-transform: uppercase;
          font-family: Arial, sans-serif;
        }
      `}</style>
      <div className="print-watermark">{text}</div>
    </>
  );
};

export default PrintWatermark;
